export enum ConsentDocumentTypeEnum {
    PartOne = 1,
    PartOneDescription = 'Part One',
    PartTwo = 2,
    PartTwoDescription = 'Part Two',
}
